import React, { useState } from 'react'
import "./Navbar.css"
import mainimage from "./NavbarImage.png"


function Navbar() {
  const [dropDownFLag, setdropDownFLag] = useState(false)

  return (
    <div className='mainDash h-[128px] flex items-center justify-between px-3 sm:px-[5%] relative'>
      <img src={mainimage} alt="Bear Buster" />
      <div className='sm:flex gap-[60px] hidden  '>
        <div className='Gunterz italic text-white'>
          Dashboard
        </div>
        <div className='Gunterz italic text-white'>
          Games
        </div>
      </div>
      <svg  onClick={() => setdropDownFLag(!dropDownFLag)} fill="#FFFFFF" className='w-[30px] h-[30px] sm:hidden flex-shrink-0' version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330 330" stroke="#FFFFFF"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_225_" d="M325.607,79.393c-5.857-5.857-15.355-5.858-21.213,0.001l-139.39,139.393L25.607,79.393 c-5.857-5.857-15.355-5.858-21.213,0.001c-5.858,5.858-5.858,15.355,0,21.213l150.004,150c2.813,2.813,6.628,4.393,10.606,4.393 s7.794-1.581,10.606-4.394l149.996-150C331.465,94.749,331.465,85.251,325.607,79.393z"></path> </g></svg>
      
      {dropDownFLag?
       <div className='sm:hidden mainDash flex flex-col items-center absolute top-[100%] left-0 w-full'>
        <div className='Gunterz italic text-white p-3'>
          Dashboard
        </div>
        <div className='Gunterz italic text-white p-3'>
          Games
        </div>
     </div>
     :""
      }
     

    </div>
  )
}

export default Navbar
